export const isEmptyList = (list: Array<any>) => {
  if (!list.length) {
    return true
  }
  if (!list.reduce((acc, cur) => acc.concat(Object.values(cur).join('')), '').length) {
    return true
  }
  return false
}